<template>
  <div class="columns is-multiline is-mobile">
    <div class="column">
      <window title="Input multiplier">
        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px"
          class="demo-dynamic"
        >
          <el-form-item prop="email" label="Email" :rules="[
            { required: true, message: 'Please input email address', trigger: 'blur' },
            {
              type: 'email',
              message: 'Please input correct email address',
              trigger: ['blur', 'change']
            }
          ]">
            <el-input style="width:80%" v-model="dynamicValidateForm.email"></el-input>
          </el-form-item>
          <el-form-item v-for="(domain, index) in dynamicValidateForm.domains"
            :label="'Domain' + index" :key="domain.key" :prop="'domains.' + index + '.value'"
            :rules="{
              required: true, message: 'domain can not be null', trigger: 'blur'
            }"
          >
            <el-input style="width:80%" v-model="domain.value"></el-input>
            <button style="margin-left: 20px" class="button" @click.prevent="removeDomain(domain)">
              Delete
            </button>
          </el-form-item>
          <el-form-item>
            <div class="buttons">
              <button class="button is-primary" type="primary"
                @click.prevent="submitForm('dynamicValidateForm')"
              >
                Submit
              </button>
              <button class="button" @click.prevent="addDomain">New domain</button>
              <button class="button" @click.prevent="resetForm('dynamicValidateForm')">
                Reset
              </button>
            </div>
          </el-form-item>
        </el-form>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dynamicValidateForm: {
        domains: [{
          key: 1,
          value: '',
        }],
        email: '',
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      const index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        key: Date.now(),
        value: '',
      });
    },
  },
};
</script>
